import React, { useState } from 'react'
import API_URL from '../common/Apiurl';
import { useNavigate } from "react-router-dom";
import SuccessMessage from '../common/Message';

function Resetpassword(){
    const apiUrl = API_URL;
    const [successMessages, setSuccessMessages] = useState([]);
    const [passwordmatch, setPasswordmatch] = useState(true);
    var getEmail = localStorage.getItem('userEmail');
    const updatepassword = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const getpassword = data.get('password')
        const getconfirmpassword = data.get('password_confirmation')
        if(getpassword != getconfirmpassword){
            setPasswordmatch(false)
            return false;
        }else{
            setPasswordmatch(true)
        }
        const emailData = {
            emailId: getEmail,
            password:getpassword
        }
        const sendEmail = await fetch(`${apiUrl}/admin/changeadminpassword`,{
            method: 'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(emailData)
        })
        const getData = await sendEmail.json()
        console.log(getData)
        if(getData.status === 200){
            localStorage.removeItem("userEmail",getEmail)
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if(getData.status !== 200){
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return(
        <>
            <form className="resetForm col-sm-6 mx-auto" onSubmit={updatepassword}>
                <h1 className="mt-5">Reset Password</h1>
                    <div className="formcontainer">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <input type="hidden" name="id" value="" />
                                    <label htmlFor="password"><strong>Password</strong></label>
                                    <input type="password" name="password" placeholder="New Password" required />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-sm-12">
                                    <label htmlFor="password_confirmation"><strong>Confirm Password</strong></label>
                                    <input type="password" name="password_confirmation" placeholder="Confirm Password" required />
                                </div>
                            </div>
                            {passwordmatch?' ':'Password and confirm password must be same.'}
                            <a className="aTag" href='http://3.13.248.165/'>Return to home page</a>
                        </div>
                        <div className="row">
                            <div className="col-sm-5">
                                <input className="button" type="submit" />
                            </div>
                        </div>                        
                    </div>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
            </form>
        </>
    )
}

export default Resetpassword;